<template>
<!--  -->
<div class="side-panel left com-left hf osy ml-30">
  <div class="side-panel-bg">
    <div class="pt-20 pl-20 pb-5 pr-20  thisMonthData" >
      <h1 class="f-20 c-satwo">算力运行 <img src="/imgs/titleicon.png" class="ml-10"></h1>
      <h3 class="f-14 pt-20 c-satwotitle">能耗使用</h3>
      <div class="fr ov bleftOne">
        <chart-power :chartData='dataenergyTrend' style="width: 100%; height: 140px;"></chart-power>
      </div>
    </div>
    <div style="text-align: center;"><img src="/imgs/saline.png"></div>
    <div class="pt-10 pl-20 pb-5 pr-20">
      <h3 class="f-14 c-satwotitle">算力使用情况</h3>
      <chart-bar-single class="f1 oh mt-20" fill :chart-data="datacomputilityUse" style="height: 150px;"></chart-bar-single>
    </div>
    <div style="text-align: center;"><img src="/imgs/saline.png"></div>
    <div class="pt-10 pl-20 pb-5 pr-20">
      <h3 class="f-14 c-satwotitle">算力任务类型</h3>
      <chart-pietwo :data1="datataskType" :data2="datataskTypeComput"  style="height:150px;"></chart-pietwo>
    </div>
    <div style="text-align: center;"><img src="/imgs/saline.png"></div>
    <div class="pt-10 pl-20 pr-20">
      <h3 class="f-14 c-satwotitle">算力应用方向</h3>
      <div class="mt-10 bleftThree">
        <chart-rose :data="datacomputingUse" style="height:200px;"></chart-rose>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import chartPower from './chart-power.vue'
import chartBarSingle from './chart-bar-single.vue'
import chartPietwo from './chart-pietwo'
import chartRose from './chart-rose'

export default {
  name: 'com-left',
  components: {
    chartPower,
    chartBarSingle,
    chartPietwo,
    chartRose,
  },
  props: ['dataenergyTrend', 'datacomputilityUse', 'datataskType', 'datataskTypeComput', 'datacomputingUse'],
  data () {
    return {

    }
  },
  methods: {}
}
</script>

<style lang="scss">
.thisMonthData{
  .bleftOne>div{background:url(/imgs/border-leftOne.png) no-repeat; width:120px; height:69px; background-size:100% 69px;}
  .bleftTwo>div{background:url(/imgs/border-leftTwo.png) no-repeat;height:68px;background-size: 100%;}
}
.bleftThree{background:url(/imgs/border-leftThree.png) no-repeat;height: 225px;background-size: 100%;padding: 5px 0;}
</style>
